<script setup lang="ts">
defineProps<{
  eyebrow?: string;
  title: string;
  description?: string;
}>();
</script>

<template>
  <main class="min-h-[60vh] bg-white">
    <div class="mx-auto w-full max-w-[1280px] px-4">
      <div class="mx-auto w-full max-w-[1180px]">
        <div class="w-full pt-8 text-left sm:pt-12">
          <p
            v-if="eyebrow"
            class="mb-4 text-xs font-bold uppercase tracking-[0.14em] text-primary"
          >
            {{ eyebrow }}
          </p>

          <h1
            class="max-w-[980px] text-balance font-gabarito text-[40px] font-bold leading-[1] tracking-[-0.03em] text-app-text sm:text-[50px] lg:text-[60px]"
          >
            {{ title }}
          </h1>

          <p
            v-if="description"
            class="mt-5 max-w-[820px] text-pretty text-base leading-7 text-app-muted sm:text-lg sm:leading-8"
          >
            {{ description }}
          </p>
        </div>

        <div class="py-12 text-left sm:py-16 lg:py-20">
          <slot />
        </div>
      </div>
    </div>
  </main>
</template>
